module.exports = __webpack_public_path__ + "static/media/sunflowerPaintings.13b8f6be.jpg";